function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarsFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Component 469 \\u2013 14",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h64v64H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.246 14.316a.583.583 0 0 0 .586-.516c.656-3.75.61-3.914 4.664-4.664a.561.561 0 0 0 .515-.563.568.568 0 0 0-.515-.586c-4.055-.7-4.008-.867-4.664-4.664a.583.583 0 0 0-.586-.516.546.546 0 0 0-.562.516C25 7.1 25.074 7.238 21 7.988a.584.584 0 0 0-.516.586.565.565 0 0 0 .539.563c4.031.727 3.984.891 4.664 4.664a.546.546 0 0 0 .559.515zM14.9 30.7a.851.851 0 0 0 .867-.8c.82-6.211 1.008-6.234 7.477-7.453a.883.883 0 0 0 0-1.758c-6.445-.891-6.656-1.1-7.477-7.43a.855.855 0 0 0-.867-.82.865.865 0 0 0-.891.844c-.773 6.211-1.055 6.211-7.477 7.406a.873.873 0 0 0-.8.891c0 .492.328.8.891.867 6.352 1.008 6.609 1.2 7.383 7.406a.865.865 0 0 0 .894.847zm16.2 25.991a1.394 1.394 0 0 0 1.383-1.266c1.687-12.7 3.469-14.625 15.984-16.008a1.4 1.4 0 0 0 0-2.789c-12.492-1.453-14.226-3.3-15.984-16.008a1.388 1.388 0 0 0-2.766 0c-1.687 12.7-3.469 14.625-15.961 16.008a1.405 1.405 0 0 0-1.336 1.383 1.423 1.423 0 0 0 1.313 1.406c12.469 1.664 14.18 3.3 15.984 16.008a1.411 1.411 0 0 0 1.383 1.266z",
    transform: "translate(4.928 2.525)",
    style: {
      fill: "currentColor"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarsFilled);
export default __webpack_public_path__ + "static/media/stars-filled.17def9eb.svg";
export { ForwardRef as ReactComponent };